import React from 'react';

// AutoHire logo — the "Candidate" mark: an ink rounded-square tile holding a
// white checkmark whose lower-left tip is a light-blue dot (a sourced candidate
// lifting into a confident hire), paired with a Source Serif wordmark.
// Brand: ink #0F172A, accent blue #2563EB, dot #60A5FA. Matches AutoHire Logo.dc.html.
const INK = '#0F172A';
const DOT = '#60A5FA';

export function LogoMark({ size = 28 }) {
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-flex', width: size, height: size, flex: 'none',
        alignItems: 'center', justifyContent: 'center',
        borderRadius: Math.round(size * 0.28), background: INK,
      }}
    >
      <svg width={Math.round(size * 0.62)} height={Math.round(size * 0.62)} viewBox="0 0 24 24" fill="none">
        <path d="M6.5 12.5l3.6 3.6L18 6.4" stroke="#ffffff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="6.5" cy="12.5" r="2.2" fill={DOT} />
      </svg>
    </span>
  );
}

export default function Logo({ size = 28, className = '', textClassName = 'text-gray-900 dark:text-white' }) {
  return (
    <span className={`inline-flex items-center ${className}`} style={{ gap: Math.round(size * 0.34) }}>
      <LogoMark size={size} />
      <span className={`font-serif font-semibold tracking-tight ${textClassName}`}
        style={{ fontSize: Math.round(size * 0.72), lineHeight: 1 }}>
        AutoHire
      </span>
    </span>
  );
}
